import * as React from 'react';

const PolishIcon = ({ size = 36 }) => {
    return (
        <svg width={size} height={size} viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <clipPath id='circle-pl'>
                <circle cx={15} cy={11} r={10} />
            </clipPath>
            <g clipPath='url(#circle-pl)'>
                <rect x={5} y={1} width={20} height={10} fill='#FFFFFF' />
                <rect x={5} y={11} width={20} height={10} fill='#DC143C' />
            </g>
            <circle cx={15} cy={11} r={10} stroke='#e0e0e0' strokeWidth={0.5} fill='none' />
        </svg>
    );
};

export default PolishIcon;
